import { useAuth } from "@mindlercare/auth-ui";
import { countries } from "@mindlercare/schema";
import { useFlag } from "@mindlercare/unleash-client";

export const useMedicoreEnabled = (patientUserId?: number) => {
  const { market } = useAuth();
  const isMedicoreApiV3Enabled = useFlag("MEDICORE_API_V3");
  return (
    isMedicoreApiV3Enabled &&
    !!patientUserId &&
    market === countries.NL.codeISO2
  );
};
